import React from 'react';
import './divider.scss';

const DividerComponent = ({ type = 'primary' }) => {
	return <div className={`divider_main_container" ${type}_divider`} />;
};

export default DividerComponent;
